exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#keys {\r\n  background-color: red;\r\n}\r\n\r\nbody {\r\n}\r\n\r\nhtml {\r\n  white-space: nowrap;\r\n  overflow: auto;\r\n  overflow-x: auto;\r\n}\r\n\r\ncanvas {\r\n  all: unset;\r\n  display: inline-block;\r\n  width: 100vw !important;\r\n  height: 100vh !important;\r\n  transition: 0.5s;\r\n}\r\n", ""]);

